export default __webpack_public_path__ + "static/media/coming-soon-pic.020b8dc3.png";